
import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CImage,
  CButton,
  CAccordion, 
  CAccordionBody, 
  CAccordionHeader, 
  CAccordionItem
} from '@coreui/react-pro'

import FormTextAreaInput from './FormTextAreaInput'
import FormTextInput from './FormTextInput'
import FormSelectInput from './FormSelectInput'

// icons
import AddMoreIconWhite from '../../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

const FormClientAdditionalAddress = ({
  colSize,
  inputLabel,
  className,
  additional_address,
  handleAddAdditionalAddress,
  errors,
  countryOptions,
  provinceOptions,
  handleChange,
  handleRemoveAdditionalAddress,
  isDetail,
  handleSelectInputArea
}) => {
  return (
    <CCol lg={colSize} className={className} id='additional_address'>
      <div className='mb-3 d-grid gap-2 d-md-flex justify-content-between align-items-center'>
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
        {
          !isDetail && (
            <CButton
              onClick={() => handleAddAdditionalAddress()}
              style={styleButtonVars2}
            >
              <CImage fluid src={AddMoreIconWhite} className='me-2' />
              {additional_address?.length > 0 ? 'Add More' : 'Add'}
            </CButton>
          )
        }
      </div>
      {additional_address?.length > 0 ? (
        additional_address?.map((inputField, index) => {
          return (
            <CAccordion activeItemKey={isDetail ? 0 : index+1}>
              <CAccordionItem itemKey={index+1} className='mb-2'>
                <CAccordionHeader>Address {index + 1}{inputField?.name ? `: ${inputField?.name}` : ''}</CAccordionHeader>
                <CAccordionBody>
                  <CRow className="mb-4">
                    <FormTextInput 
                      id='name'
                      name='name'
                      colSize='6'
                      inputLabel='Name'
                      className='mb-3'
                      placeholder='Enter address name...'
                      value={inputField?.name}
                      handleTextInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.name}
                      invalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.name}
                      disabled={isDetail}
                    />
                    <FormTextAreaInput
                      id='address'
                      name='address'
                      colSize='6'
                      inputLabel='Address'
                      className='mb-3'
                      placeholder='Enter address...'
                      rows='5'
                      value={inputField?.address}
                      handleTextAreaInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.address}
                      invalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.address}
                      disabled={isDetail}
                    />
                    <FormSelectInput 
                      id='country_id'
                      name='country_id'
                      colSize='6'
                      inputLabel='Country'
                      className='mb-3'
                      selectOptions={countryOptions}
                      value={inputField?.country_value}
                      handleSelectInput={e => handleSelectInputArea(e, index, 'country')}
                      feedbackInvalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.country_id}
                      invalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.country_id}
                      disabled={isDetail}
                      placeholder='Please select country...'
                    />
                    {
                      inputField?.country_value?.label?.includes("Indonesia") && (
                        <>
                          <FormSelectInput 
                            id='province_id'
                            name='province_id'
                            colSize='6'
                            inputLabel='Province'
                            className='mb-3'
                            selectOptions={provinceOptions}
                            value={inputField?.province_value}
                            handleSelectInput={e => handleSelectInputArea(e, index, 'province')}
                            feedbackInvalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.province_id}
                            invalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.province_id}
                            disabled={isDetail}
                            placeholder='Please select province...'
                          />
                          <FormSelectInput 
                            id='city_id'
                            name='city_id'
                            colSize='6'
                            inputLabel='City'
                            className='mb-3'
                            selectOptions={inputField?.city_options || []}
                            value={inputField?.city_value}
                            handleSelectInput={e => handleSelectInputArea(e, index, 'city')}
                            feedbackInvalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.city_id}
                            invalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.city_id}
                            disabled={isDetail}
                            placeholder='Please select city...'
                          />
                          <FormSelectInput 
                            id='district_id'
                            name='district_id'
                            colSize='6'
                            inputLabel='District'
                            className='mb-3'
                            selectOptions={inputField?.district_options || []}
                            value={inputField?.district_value}
                            handleSelectInput={e => handleSelectInputArea(e, index, 'district')}
                            feedbackInvalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.district_id}
                            invalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.district_id}
                            disabled={isDetail}
                            placeholder='Please select district...'
                          />
                          <FormSelectInput 
                            id='subdistrict_id'
                            name='subdistrict_id'
                            colSize='6'
                            inputLabel='Sub District'
                            className='mb-3'
                            selectOptions={inputField?.subdistrict_options || []}
                            value={inputField?.subdistrict_value}
                            handleSelectInput={e => handleSelectInputArea(e, index, 'subdistrict')}
                            feedbackInvalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.subdistrict_id}
                            invalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.subdistrict_id}
                            disabled={isDetail}
                            placeholder='Please select subdistrict...'
                          />
                          <FormTextInput 
                            id='postal_code'
                            name='postal_code'
                            colSize='6'
                            inputLabel='Postal Code'
                            className='mb-3'
                            placeholder='Enter postal code...'
                            value={inputField?.postal_code}
                            handleTextInput={(e) => handleChange(e, index)}
                            feedbackInvalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.postal_code}
                            invalid={errors?.additional_address?.length > 0 && errors?.additional_address[index]?.postal_code}
                            disabled={isDetail}
                          />
                        </>
                      )
                    }
                  </CRow>
                  <CRow>
                    <CCol lg={1}>
                      {
                        additional_address?.length > 1 && !isDetail && (
                          <CButton
                            style={styleButtonVars2}
                            onClick={() => {handleRemoveAdditionalAddress(inputField, index)}}
                          >
                            Delete
                          </CButton>
                        )
                      }
                    </CCol>
                  </CRow>
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>

          )
        })
      ) : !isDetail ? (
        <div className='alert alert-secondary'><b>You can add additional client address</b></div>
      ) : (
        <div className='alert alert-secondary'><b>You not have additional client address</b></div>
      )}
    </CCol>
  )
}

export default FormClientAdditionalAddress
